import { Injectable } from "@angular/core";
import { ApiService } from "@edp-services/api.service";

@Injectable({
    providedIn: "root",
})
export class SolarService {
    constructor(private apiService: ApiService) { }

    public getSolarContract(account_number: string ) {
        return this.apiService.callServicePostToCollectionCatalog("solar.getInstallments", { account_number });
    }
}
